import { Injectable } from '@angular/core';
import { BehaviorSubject, first } from 'rxjs';
import { ContactSearchVM, ProjectSecurityVM, ProjectService, ProjectVM } from './api';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  sourceApp: String = "";
  allowedProjects: ProjectSecurityVM[] = [];
  private _selectedProject:ProjectSecurityVM = {}
  set selectedProject(val: ProjectSecurityVM){
    this._selectedProject = val;
    this.selectedProject$.next(val);
    this.getProjectLists();
  }
  get selectedProject():ProjectSecurityVM{
    return this._selectedProject;
  }
  user:ContactSearchVM = <ContactSearchVM>{};
  user$ = (new BehaviorSubject<ContactSearchVM>(this.user));
  selectedProject$ = (new BehaviorSubject<ProjectSecurityVM>(this.selectedProject))
  isAdmin: boolean = false;
  collapseLeftMenu:boolean = false;
  currentStatus: string = "NO STATUS";
  scanned: string = "SCANNED";
  notScanned: string = "NOT SCANNED";
  checkedOut: string = "CHECKED OUT";
  returned: string = "RETURNED";
  suspectedMissing: string = "SUSPECTED MISSING";
  suspectedStolen: string = "SUSPECTED STOLED";
  confirmedMissing: string = "CONFIRMED MISSING";
  confirmedStoled: string = "CONFIRMED STOLEN";
  lockedOut: string = "LOCKED OUT";
  inactive: string = "INACTIVE";

  participantTypeList:string[] = [];
  activityTypeList:string[] =[];
  siteType:string[] = [];
  schoolType:string[] = [];

  getStatisticsColor(val:string){

    switch (val) {
      case this.scanned:
      case "RECENT SCANS":
        case "CHECKED IN":
        return "#0064A2"
        break;
      case this.notScanned:
       case "EXPIRED SCANS":
       case "NO SCAN":
        return "#00B4AF";
        break;
      case this.checkedOut:
        return "#0687C6";
        break;
      case this.returned:
        case "Registered Schools":
          case "Registered Devices":
        return "#95C53E";
        break;
      case this.suspectedMissing:
        return "#F7941D";
        break;
      case this.suspectedStolen:
        return "#E35325";
        break;
      case this.confirmedMissing:
        return "#DD3756";
        break;
      case this.confirmedStoled:
        return "#ED1C24";
        break;
      case this.lockedOut:
        return "#231F20";
        break;
      case this.inactive:
        return "#939598";
        break;
    }
    return "#939598";
  }

  constructor(private projectService:ProjectService) { }

  setUser(user:ContactSearchVM){
    this.user = user;
    this.user$.next(user);
  }

  setSourceApp(source: string){
    this.sourceApp = source;
  }

  getProjectLists(){
    this.projectService.projectGetProjectCustomListGet("Participant Type",this.selectedProject.projectId).pipe(first()).subscribe(result=>{
      this.participantTypeList= result.map(obj=>obj.itemName!);
    })
    this.projectService.projectGetProjectCustomListGet("Activity Type",this.selectedProject.projectId).pipe(first()).subscribe(result=>{
      this.activityTypeList= result.map(obj=>obj.itemName!);
    })
    this.projectService.projectGetProjectCustomListGet("Site Type",this.selectedProject.projectId).pipe(first()).subscribe(result=>{
      this.siteType= result.map(obj=>obj.itemName!);
    })
    this.projectService.projectGetProjectCustomListGet("School Type",this.selectedProject.projectId).pipe(first()).subscribe(result=>{
      this.schoolType= result.map(obj=>obj.itemName!);
    })
  }

}
